module.exports = __webpack_public_path__ + "img/products.d5a95349.svg";